import { Amplify, type ResourcesConfig } from 'aws-amplify';

/**
 * Deep-merges a partial Amplify config onto the existing singleton config.
 *
 * Amplify v6 replaces the entire config on every `Amplify.configure()` call.
 * Both Kinesis (Analytics + Identity Pool) and Cognito Auth (User Pool) need
 * to coexist in the same singleton, so each caller passes only its own slice
 * and this utility merges them safely regardless of call order.
 */
export function mergeAmplifyConfig(partial: ResourcesConfig): void {
  const existing = Amplify.getConfig();

  const { Auth: existingAuth, Analytics: existingAnalytics, ...existingRest } = existing;
  const { Auth: partialAuth, Analytics: partialAnalytics, ...partialRest } = partial;

  Amplify.configure({
    ...existingRest,
    ...partialRest,
    Auth: {
      Cognito: {
        ...existingAuth?.Cognito,
        ...partialAuth?.Cognito,
      },
    } as ResourcesConfig['Auth'],
    Analytics: {
      ...existingAnalytics,
      ...partialAnalytics,
    },
  });
}
